<!-- =========================================================================================
  File Name: RoutingSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<vs-sidebar
		click-not-close
		default-index="1"
		class="items-no-padding route-sidebar"
		:class="componentParent === 'OPTIMIZATION' ? 'add-new-data-sidebar' : ''"
		v-model="isSidebarActiveLocal"
	>
		<div class="mt-2 flex items-center justify-between px-4">
			<h4>{{ $t("Routing.RouteResult.Routes") }}</h4>
			<feather-icon
				:icon="'XIcon'"
				svgClasses="w-4 h-4 m-2"
				class="cursor-pointer bg-primary text-white rounded-full"
				@click="isSidebarActiveLocal = false"
			/>
		</div>
		<vs-divider class="mt-1 mb-1"></vs-divider>
		<div class="lg:block pl-2 pr-2 mb-4">
			<div class="vx-col w-full my-1">
				<label class="vs-input--label">{{ $t("SearchBy") }}</label>
				<v-select
					v-model="searchFieldSelected"
					v-validate="'required'"
					:clearable="false"
					:options="searchOptions"
					:dir="$vs.rtl ? 'rtl' : 'ltr'"
				>
					<template v-slot:no-options="{search, searching}">
						<template v-if="searching">
							{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
						</template>
					</template>
				</v-select>
			</div>
			<vs-input
				v-if="searchFieldSelected.value === 'vehicle'"
				v-model="searchQuery"
				class="w-full"
				:placeholder="$t('Add') + ' ' + $t('Identification')"
			/>
			<div v-else class="vx-col w-full my-1">
				<v-select
					class="select-large"
					v-model="searchQueryVisitPoint"
					:clearable="true"
					:options="visitPointOptions"
					:dir="$vs.rtl ? 'rtl' : 'ltr'"
					:placeholder="$t('Add') + ' ' + $t('Identification')"
				>
					<template v-slot:no-options="{search, searching}">
						<template v-if="searching">
							{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
						</template>
					</template>
					<template #option="{value, vehicleId}">
						{{ value }}
						<br />
						<cite style="font-size: 12px">{{ $t("Vehicles.AssignedVehicle") + ": " + vehicleId }}</cite>
					</template>
				</v-select>
			</div>
		</div>
		<div class="tab-size" :style="{overflowY: 'auto', height: windowHeight < 600 ? 90 + 'vh' : 54 + 'vh'}">
			<vue-perfect-scrollbar class="scroll-area" :settings="settings">
				<vs-list v-for="(element, index) in getRoutedVehicles" :key="index" class="pb-0 pt-1">
					<div
						v-if="renderComponent"
						:id="'card-route' + index"
						:style="
							index === indexValidation
								? {
										background: '#' + element.color,
										padding: '2px',
										borderRadius: '6px',
										fontSize: '1.2em',
										fontWeight: 'bold',
										boxShadow: `0 0 6px 1px #${element.color}`,
								  }
								: {fontWeight: 'lighter'}
						"
					>
						<vx-card
							card-border
							class="cursor-pointer"
							@click.prevent="loadIndividualRoute(element, index)"
						>
							<vs-list-item :title="element.vehicle_id">
								<template slot="subtitle">
									<div class="wrapper mt-2">
										<div
											class="transport mr-2"
											:title="
												element.profile === 'car'
													? $t('RoutingType.Transport') +
													  ' ' +
													  $t('Routing.Car').toLowerCase()
													: element.profile === 'walk'
													? $t('RoutingType.Transport') +
													  ' ' +
													  $t('Routing.Walking').toLowerCase()
													: element.profile === 'motorcycle'
													? $t('RoutingType.Transport') +
													  ' ' +
													  $t('Routing.Motorcycle').toLowerCase()
													: element.profile === 'truck'
													? $t('RoutingType.Transport') +
													  ' ' +
													  $t('Routing.Truck').toLowerCase()
													: element.profile === 'scooter'
													? $t('RoutingType.Transport') +
													  ' ' +
													  $t('Routing.Scooter').toLowerCase()
													: element.profile === 'bus'
													? $t('RoutingType.Transport') +
													  ' ' +
													  $t('Routing.Bus').toLowerCase()
													: element.profile === 'unknown'
													? $t('RoutingType.Transport') + ' ' + $t('NotSpecified')
													: $t('RoutingType.Transport') +
													  ' ' +
													  $t('Routing.Bicycle').toLowerCase()
											"
										>
											<vs-icon
												class="icon-material"
												:style="'font-size: 1.3rem'"
												:icon="getIcon(element.profile)"
											></vs-icon>
										</div>
										<div class="distance mr-2" :title="$t('Routing.DistanceRoute')">
											<div class="flex">
												<vs-icon class="icon-material" icon="power_input"></vs-icon>
												<label class="ml-2" style="font-size: 11px">{{
													element.distance_route.toFixed(1) + " km"
												}}</label>
											</div>
										</div>
										<div class="visit-point mr-2" :title="$t('RouterSelection.VisitPoints')">
											<div class="flex items-center">
												<vs-icon class="icon-material" icon="location_on"></vs-icon>
												<label class="ml-2" style="font-size: 11px">{{
													element.total_visit_points
												}}</label>
											</div>
										</div>
										<div class="time-driving mr-2" :title="$t('Routing.RouteResult.DrivingTimme')">
											<div class="flex items-center">
												<vs-icon class="icon-material" icon="schedule"></vs-icon>
												<label class="ml-2" style="font-size: 11px">{{
													element.minimum_driving_time
												}}</label>
											</div>
										</div>
									</div>
								</template>
							</vs-list-item>
						</vx-card>
					</div>
					<input
						type="color"
						name="color"
						class="input-feature"
						style="right: 62px"
						:title="$t('Routing.RouteResult.ChangeColorRoute')"
						:value="getColor(element.color)"
						@input="changeColor($event.target.value, element)"
					/>
					<vx-tooltip
						style="z-index: 99999"
						color="primary"
						position="right"
						delay=".1s"
						:text="$t('Routing.RouteResult.RespectPlannedRoute')"
					>
						<vs-checkbox
							style="position: absolute; top: 12px; right: 28px"
							v-model="element.check"
							@change="changeCheck(element, $event.target.checked)"
						/>
					</vx-tooltip>
					<div v-if="1 === 2" class="checkbox-wrap">
						<label class="switch">
							<input
								class="switch-input"
								v-if="showCheckboxRoute"
								type="checkbox"
								checked
								:title="$t('Routing.RouteResult.HideRoute')"
								@input="toggleRoutesSidebar($event.target.checked, element)"
							/>
							<span class="switch-label" data-on="On" data-off="Off"></span>
						</label>
					</div>
					<vs-button
						:id="'route' + index"
						v-if="showCheckboxRoute"
						style="
							position: absolute;
							top: 12px;
							right: 12px;
							width: 22px !important;
							height: 22px !important;
						"
						icon-pack="feather"
						type="filled"
						:icon="!element.showRoute ? 'icon-eye-off' : 'icon-eye'"
						:title="
							!element.showRoute ? $t('Routing.Buttons.SeeRoute') : $t('Routing.RouteResult.HideRoute')
						"
						@click.prevent="toggleRoutesSidebar(element)"
					></vs-button>
				</vs-list>
			</vue-perfect-scrollbar>
		</div>
	</vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import Utils from "@/helpers/Utils";

export default {
	name: "RoutingSidebar",
	props: {
		routedVehicles: {
			type: Array,
			default: () => [],
		},
		isSidebarActive: {
			type: Boolean,
			default: false,
		},
		showCheckbox: {
			type: Boolean,
			default: true,
		},
		polylineList: {
			type: Array,
			default: () => [],
		},
		markerList: {
			type: Array,
			default: () => [],
		},
		componentParent: {
			type: String,
			default: "ROUTING-SIDEBAR",
		},
		indexValidation: {
			type: Number,
			default: null,
		},
	},
	components: {
		VuePerfectScrollbar,
		vSelect,
	},
	data() {
		return {
			routeColor: "",
			activeItem: 0,
			type: "Options",
			tabActive: 0,
			windowHeight: screen.height,
			renderComponent: true,
			searchQuery: null,
			searchQueryVisitPoint: null,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			optionsProgramedRoute: {
				strokeColor: "#32BA7C",
			},
			searchFieldSelected: {value: "vehicle", label: this.$t("Vehicles.Vehicle")},
		};
	},
	watch: {
		searchQueryVisitPoint(val) {
			if (val) {
				this.handleSelected(val.value);
			}
		},
		searchFieldSelected(val) {
			if (val) {
				this.searchQueryVisitPoint = null;
				this.searchQuery = null;
			}
		},
		indexValidation: {
			handler(newVal) {
				// Forzar re-render cuando cambia indexValidation
				if (newVal === null) {
					this.forceRender();
				}
			},
			immediate: true,
		},
	},
	computed: {
		showCheckboxRoute: {
			get() {
				return this.showCheckbox;
			},
			set() {},
		},
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			},
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
		getColor() {
			return (color) => {
				return "#" + color;
			};
		},
		getRoutedVehicles() {
			if (this.searchFieldSelected.value === "visitPoint" && this.searchQueryVisitPoint) {
				this.searchQuery = this.searchQueryVisitPoint.vehicleId;
			}
			const isSearchQueryEmpty = !this.searchQuery || this.searchQuery.trim().length === 0;
			if (
				isSearchQueryEmpty ||
				(this.searchFieldSelected.value === "visitPoint" && !this.searchQueryVisitPoint)
			) {
				this.markerList.forEach((m) => m.setAnimation(null));
				return this.routedVehicles;
			}
			return this.routedVehicles.filter((r) => {
				return r.vehicle_id.toLowerCase().includes(this.searchQuery.toLowerCase());
			});
		},
		getIcon() {
			return function (param) {
				let icon = "";
				switch (param) {
					case "car":
						icon = "local_taxi";
						break;
					case "walk":
						icon = "directions_walk";
						break;
					case "bicycle":
						icon = "directions_bike";
						break;
					case "motorcycle":
						icon = "motorcycle";
						break;
					case "truck":
						icon = "local_shipping";
						break;
					case "scooter":
						icon = "rv_hookup";
						break;
					case "bus":
						icon = "directions_bus";
						break;
					case "unknown":
						icon = "bus_alert";
						break;
				}
				return icon;
			};
		},
		searchOptions() {
			return [
				{value: "vehicle", label: this.$t("Vehicles.Vehicle")},
				{value: "visitPoint", label: this.$t("VisitPoint")},
			];
		},
		visitPointOptions() {
			const visitPointList = this.routedVehicles.flatMap((item) =>
				item.routed_visit_points
					.filter((point) => point.type !== "depot" && point.type !== "break")
					.map((point) => ({
						label: point.identification,
						value: point.identification,
						vehicleId: item.vehicle_id,
					}))
			);
			return visitPointList;
		},
	},
	mounted() {
		document.querySelector(".route-sidebar .vs-sidebar").style.marginLeft = 0.9 + "%";
		document.querySelector(".route-sidebar .vs-sidebar").style.marginTop = 5 + "%";
		document.querySelector(".route-sidebar .vs-sidebar").style.zIndex = 1 + "%";
	},
	methods: {
		hex2rgb(hex) {
			const r = parseInt(hex.slice(1, 3), 16);
			const g = parseInt(hex.slice(3, 5), 16);
			const b = parseInt(hex.slice(5, 7), 16);
			return {r, g, b};
		},
		toggleRoutesSidebar(data) {
			data.showRoute = !data.showRoute;
			if (!data.showRoute) {
				this.polylineList.forEach((polyline) => {
					if (polyline.info.vehicle_id === data.vehicle_id) {
						Anuket.removeLine(polyline);
					}
				});
				const markersToHide = this.markerList.filter((t) => t.details.vehicle_id === data.vehicle_id);
				Anuket.hideMarkers(markersToHide);
			} else {
				this.polylineList.forEach((polyline) => {
					if (polyline.info.vehicle_id === data.vehicle_id) {
						Anuket.addLine(polyline);
					}
				});
				const markersToShow = this.markerList.filter((t) => t.details.vehicle_id === data.vehicle_id);
				Anuket.showMarkers(markersToShow);
			}
		},
		changeColor(color, element) {
			this.getColor(color.replace("#", ""));
			this.polylineList.forEach((polyline) => {
				if (polyline.info.vehicle_id === element.vehicle_id) {
					polyline.info.color = color.replace("#", "");
					polyline.setOptions({strokeColor: color});
					polyline.mapMarkers.forEach((marker, index) => {
						if (this.showCheckboxRoute) {
							const iconInit = Utils.addIconSvgWithLabelSmall(color.substr(1));
							marker.setIcon(iconInit);
						} else {
							const iconInit = Utils.addIconSvgWithLabel(color.substr(1), index + 1);
							marker.setIcon(iconInit);
						}
						marker.details.color = color.substr(1);
					});
				}
			});
		},
		loadIndividualRoute(data, index) {
			if (data.showRoute) {
				this.forceRender();
				this.showCheckboxRoute = false;
				this.$emit("loadIndividualRouteEmit", data, index);
			}
		},
		changeCheck(e, val) {
			e.check = val;
		},
		async forceRender() {
			this.renderComponent = false;
			await this.$nextTick();
			this.renderComponent = true;
		},
		animateMarker(markerFound) {
			this.markerList.forEach((m) => m.setAnimation(null));
			markerFound.setAnimation(google.maps.Animation.BOUNCE);
		},
		handleSelected(identification) {
			const markerFound = this.markerList.find((m) => m.title === identification);
			if (markerFound) {
				this.animateMarker(markerFound);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.add-new-data-sidebar {
	::v-deep .vs-sidebar--background {
		z-index: 51010;
		background-color: rgba(0, 0, 0, 0.7);
	}

	::v-deep .vs-sidebar {
		width: 310px;
		max-width: 90vw;

		.img-upload {
			margin-top: 2rem;

			.con-img-upload {
				padding: 0;
			}

			.con-input-upload {
				width: 100%;
				margin: 0;
			}
		}
	}
}
.content-form-assigned {
	width: 100%;
	min-height: 370px;
	max-height: 400px;
}

.icon-material {
	color: #b6afaf;
	width: 15px;
	height: 15px;
}

.input-feature {
	position: absolute;
	cursor: pointer;
	width: 20px;
	height: 20px;
	top: 12px;
}

.checkbox-wrap > .switch {
	display: block;
}

.switch {
	position: absolute;
	top: 10px;
	right: 10px;
	padding: 2px;
	display: inline-block;
	vertical-align: top;
	width: 35px;
	height: 20px;
	background-color: white;
	border-radius: 18px;
	box-shadow: inset 0 -1px white, inset 0 1px 1px rgba(0, 0, 0, 0.05);
	cursor: pointer;
	background-image: linear-gradient(to bottom, #eeeeee, white 25px);
}

.switch-input {
	position: absolute;
	top: 0;
	left: 0;
	opacity: 0;
}

.switch-label {
	position: relative;
	display: block;
	height: inherit;
	font-size: 10px;
	background: #eceeef;
	border-radius: inherit;
	box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.12), inset 0 0 2px rgba(0, 0, 0, 0.15);
	transition: 0.15s ease-out;
	transition-property: opacity;
}

.switch-label:before,
.switch-label:after {
	position: absolute;
	top: 50%;
	margin-top: -0.5em;
	line-height: 1;
	transition: inherit;
}

.switch-label:before {
	content: attr(data-off);
	right: 7px;
	color: #aaa;
	text-shadow: 0 1px rgba(255, 255, 255, 0.5);
}

.switch-label:after {
	content: attr(data-on);
	left: 8px;
	color: white;
	text-shadow: 0 1px rgba(0, 0, 0, 0.2);
	opacity: 0;
}

.switch-input:checked ~ .switch-label {
	background: #28c76f;
	box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.15), inset 0 0 3px rgba(0, 0, 0, 0.2);
}

.switch-input:checked ~ .switch-label:before {
	opacity: 0;
}

.switch-input:checked ~ .switch-label:after {
	opacity: 1;
}

.switch-green > .switch-input:checked ~ .switch-label {
	background: #4fb845;
}
.wrapper {
	display: grid;
	grid-template-columns: repeat(auto-fill, 1fr);
	grid-gap: 10px;
	align-items: center;
	justify-content: center;
}
.transport {
	grid-column: 1;
	grid-row: 1/2;
}
.distance {
	grid-column: 2;
	grid-row: 1/2;
}
.visit-point {
	grid-column: 3;
	grid-row: 1/2;
}
.time-driving {
	grid-column: 4;
	grid-row: 1/2;
}
.cost {
	grid-column: 5;
	grid-row: 1/2;
}
</style>
